// extracted by mini-css-extract-plugin
export var leftAlign = "_12-2";
export var popper = "_12-0";
export var subtitle = "_12-1";